import { bearerFetcher } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "./../endpoints/m2m-cleaning.cleaner-v3"
import { uploadBlobWithPresignedPut } from "@/utils/presignedUpload"

// 即時アップロード用: 選択時に issue + S3 PUT(pending) のみ行い uploadId を返す。
export const requestPutPhotoTourMovie = async (
    token: string,
    cleaningId: string,
    photoTourItemId: string,
    data: Blob,
    signal?: AbortSignal
): Promise<{ uploadId: string }> => {
    const issueUrl = m2mCleaning_cleanerV3.issuePhotoTourMovieUploadUrl({
        operationId: cleaningId,
        photoTourItemId
    })
    return uploadBlobWithPresignedPut({ token, issueUrl, blob: data, signal })
}

// 即時アップロード用: 送信時に complete のみ行う。確定された動画 id を返す。
export const completePhotoTourMovie = async (
    token: string,
    cleaningId: string,
    photoTourItemId: string,
    uploadId: string
): Promise<{ data?: { id: string }; error?: unknown }> => {
    try {
        const completeUrl = m2mCleaning_cleanerV3.completePhotoTourMovieUpload({
            operationId: cleaningId,
            photoTourItemId
        })
        const { data, error } = await bearerFetcher<{ id: string }>(
            token,
            completeUrl,
            { method: "POST", body: JSON.stringify({ uploadId }) }
        )
        if (error) {
            return { data: undefined, error }
        }
        if (!data?.id) {
            return {
                data: undefined,
                error: new Error("id missing in complete response")
            }
        }
        return { data, error: undefined }
    } catch (error) {
        return { data: undefined, error }
    }
}
